import * as React from 'react';
import { LinkButton, Header2, Image, Paragraph1 } from '@cian/ui-kit';

import emptyIcon from './assets/empty.svg';
import * as styles from './MobilePage.css';

export const MobilePage: React.FC<{}> = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <Image src={emptyIcon} height={136} width="auto" />
        <div className={styles['note']}>
          <Header2 textAlign="center">Сравнение доступно на{'\u00A0'}полной версии сайта</Header2>
        </div>
        <Paragraph1 textAlign="center">
          Скоро появится и{'\u00A0'}на{'\u00A0'}мобильной версии
        </Paragraph1>
      </div>
      <LinkButton fullWidth href="/">
        На главную
      </LinkButton>
    </div>
  );
};
